export default __webpack_public_path__ + "static/media/28.f71f727d.png";